import {onFind} from "@elements/init-modules-in-scope";
import {findIn} from "@elements/dom-utils";
import {getPrefixedDataSet} from "@elements/data-set-utils";

const defaultSelectors = {
    base: '.js-countdown', //wrapper element
    days: '.js-countdown__days', //element where countdown-days will be shown
    hours: '.js-countdown__hours', //element where countdown-hours will be shown
    minutes: '.js-countdown__minutes', //element where countdown-minutes will be shown
    seconds: '.js-countdown__seconds', //element where countdown-seconds will be shown
    finished: '.js-countdown__finished' //element which will be shown if countdown is finished
};

const defaultOptions = {
    endTime: '2025-01-01T00:00:00+0100', //defined end time of countdown
    prependZero: false, //defines if numbers less than 10 should get 0 prepended
};

/* 
   options: if no options are defined, defaultOptions are used
   selectors: if no selectors are defined, defaultSelectors are used
*/
export function init(options = defaultOptions, selectors = defaultSelectors) {
    onFind(selectors.base, function (baseElement) {
        createCounter(
            baseElement,
            {...defaultOptions, ...options},
            {...defaultSelectors, ...selectors}
        );
    });
}

export function createCounter(baseElement, options = defaultOptions, selectors = defaultSelectors) {
    // merge options and defaultOptions
    options = {
        ...options,
        ...getPrefixedDataSet('countdown', baseElement)
    };

    // merge selectors and defaultSelectors
    selectors = {...defaultSelectors, ...selectors};

    // countdown End Date
    let countdownDate = new Date(options.endTime).getTime();

    // Update the countdown every second
    let timeInterval = setInterval(function () {

        // Get today's date and time
        let now = new Date().getTime();

        // Calculate the time between countdown-enddate and today's date
        let distance = countdownDate - now;

        if (distance >= 0) {
            // Time calculations for days, hours, minutes and seconds
            let days = Math.floor(distance / (1000 * 60 * 60 * 24));
            let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((distance % (1000 * 60)) / 1000);

            //If option is set, prepend 0 when number is less than 10
            if (options.prependZero) {
                days = ('0' + days).slice(-2)
                hours = ('0' + hours).slice(-2)
                minutes = ('0' + minutes).slice(-2)
                seconds = ('0' + seconds).slice(-2)
            }

            // Find selector and adjust each time counter
            findIn(selectors.days, baseElement).innerHTML = days;
            findIn(selectors.hours, baseElement).innerHTML = hours;
            findIn(selectors.minutes, baseElement).innerHTML = minutes;
            findIn(selectors.seconds, baseElement).innerHTML = seconds;
        } else if( distance <= 0 && findIn(selectors.finished, baseElement)) {
            // If the countdown is finished, show finished text
            clearInterval(timeInterval);
            findIn(selectors.finished, baseElement).removeAttribute('hidden');
        }
    }, 1000);

}



